import { useState, useEffect, useRef, Fragment, useContext } from 'react'
import Image from 'next/image'
import Router from 'next/router'
import { Button, Modal } from 'antd'
// import numeral from 'numeral'
import NodeRSA from 'node-rsa'
import { FormattedMessage, injectIntl } from 'react-intl'
import { initialQuery, checkoutPayment } from '@/components/H5PC/service'
import { resCodeMsg } from '@/components/resCodeMsg';
import { ExclamationCircleOutlined } from '@ant-design/icons'
import { CommonError } from '@/components/H5PC/CommonMethod.js'
import { paymentJaPayflow } from '@/components/H5PC/service';

import _ from 'lodash'

import myContext from '@/utils/createContext'

const AlipayHK = props => {
    const { intl, urlParams, payMethods, payData, type, infoData, key, paymentProduct, isMobile, setLoading, loading,
        actualPaymentAmount,
        publicKey,
        token,
        actualPaymentCurrency } = useContext(myContext)

    const { formatMessage } = intl;


    useEffect(() => {

    }, [])

    const renderText = () => { 
        return (<>
            <p style={{textAlign: 'center'}}>
                <FormattedMessage id={`alipay+.${type}.h5.tip`} />
            </p>
            <div className='product-pay-icon-space'>
                {/* 兼容线上图片文件名大小写 */}
                <Image src={`/static/images/alipay/${type === 'gcash' ? 'GCash' : type}.svg`} alt={ type} width={141} height={46} />           
            </div>
        </>
        )
    }

    return (
        <div>
            <div className='product-text-666'>
                { renderText()}
            </div>
            <div className="h5pc-submit">
                <Button
                    className="h5pc-submit-btn"
                    type="primary"
                    htmlType="submit"
                    loading={loading}
                >

                    <span className="lock-img" ></span>
                    {formatMessage({ id: 'ga-checkout.pay' })} &nbsp;
                    {actualPaymentAmount} {actualPaymentCurrency}
                </Button>
            </div>
        </div>
    )
}

export default injectIntl(AlipayHK)
